import IconEdit from "@mui/icons-material/Edit";
import IconView from "@mui/icons-material/RemoveRedEye";
import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchUsers, resetStateUsers } from "../../app/slices/userSlice";
import { hasAccess } from "../../app/utils";
import AppDataTable from "../../components/appDataTable/appDataTable";
import EmptyDataContainer from "../../components/emptyDataContainer/emptyDataContainer";
import ErrorContainer from "../../components/errorContainer/errorContainer";
import LoadingContainer from "../../components/loadingContainer/loadingContainer";
import UserDialog from "./UserDialog";

const UserList = () => {
  const { list, error, status } = useSelector(({ users }) => users.get);
  const { activeSession } = useSelector(({ auth }) => auth);
  const dispatch = useDispatch();
  const [userList, setUserList] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [open, setOpen] = useState(false);

  const _fetchListParams = (() => {
    let _params = {};
    if (!hasAccess({ type: "name", resource: "VIEW ALL BRANCHES" })) {
      _params.BRANCHID = activeSession?.BRANCHID;
    }
    return _params;
  })();

  const columns = [
    {
      name: "USERNAME",
      label: "Username",
    },
    {
      name: "FIRST_NAME",
      label: "First Name",
    },
    {
      name: "MIDDLE_NAME",
      label: "Middle Name",
    },
    {
      name: "LAST_NAME",
      label: "Last Name",
    },
    {
      name: "ROLE_NAME",
      label: "Role",
    },
    {
      name: "EMAIL",
      label: "Email",
    },
    {
      name: "PHONE_NUMBER",
      label: "Mobile Phone",
    },
    {
      name: "STATUSDISPLAY",
      label: "Status",
    },
  ];

  const translateStatus = (status) => {
    switch (status) {
      case "A":
        return "Active";
      case "I":
        return "Inactive";
      case "D":
        return "Disabled";
      default:
        return "N/A";
    }
  };

  useEffect(() => {
    dispatch(fetchUsers());
  }, [dispatch]);

  useEffect(() => {
    if (list?.length > 0) {
      let _list = [];
      list.forEach((user) => {
        _list.push({
          ...user,
          STATUSDISPLAY: translateStatus(user.STATUS).toUpperCase(),
        });
      });
      setUserList(_list);
    } else {
      setUserList([]);
    }
  }, [list]);

  return (
    <>
      <div className="container-100 mb-20 "></div>
      <div className="flex-row">
        {hasAccess({ type: "name", resource: "EDIT USERS" }) && (
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              setOpen(true);
            }}
          >
            Register User
          </Button>
        )}
      </div>

      {status === "loading" && (
        <LoadingContainer
          hasBackground={true}
          message="Loading users"
          id="loading-container-users"
        />
      )}

      {error !== null && status !== "loading" && (
        <ErrorContainer
          id="error-container-users"
          hasBackground={true}
          message={error?.message || "An error occurred"}
          onReload={() => {
            dispatch(resetStateUsers());
            dispatch(fetchUsers(_fetchListParams));
          }}
        />
      )}

      {status === "idle" && list?.length <= 0 && (
        <EmptyDataContainer
          message="No users found"
          hasBackground={true}
          id="empty-data-users"
        />
      )}

      {list?.length > 0 && error === null && status === "idle" && (
        <AppDataTable
          id="users-list"
          action={[
            {
              action: hasAccess({ type: "name", resource: "EDIT USERS" })
                ? "Update"
                : "View",
              onClick: (item) => {
                setSelectedUser(item);
                setOpen(true);
              },
            },
          ]}
          actionIcon={
            hasAccess({ type: "name", resource: "EDIT USERS" }) ? (
              <IconEdit color="secondary" />
            ) : (
              <IconView color="secondary" />
            )
          }
          columns={columns}
          data={userList}
          emptyMessage="No users found"
          rowsPerPageOptions={[10, 20, 50, 100]}
          downloadFileName="System Users"
        />
      )}

      {open && (
        <UserDialog
          selectedUser={selectedUser}
          open={open}
          handleClose={() => {
            selectedUser && dispatch(fetchUsers(_fetchListParams));
            setSelectedUser(null);
            setOpen(false);
            dispatch(fetchUsers());
          }}
        />
      )}
    </>
  );
};

export default UserList;
